import { usePrefetchQuery as usePrefetchExclusivityDetails } from "@faire/web-api/api/exclusivity-agreements/exclusivityAgreementToken/get-hooks";
import { QueryParameters as GetProtectionZoneQueryParameters } from "@faire/web-api/api/exclusivity-agreements/retailers/retailerToken/protection-zone/get";
import { usePrefetchQuery as usePrefetchProtectionZoneQuery } from "@faire/web-api/api/exclusivity-agreements/retailers/retailerToken/protection-zone/get-hooks";
import { Modal } from "@faire/web/slate/Modal";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import { useState } from "@faire/web/ui/hooks/useState";
import { Suspense } from "@faire/web/ui/Suspense";
import React, { useEffect } from "react";

import { useRetailerStore } from "@faire/retailer/stores/domain/RetailerStore";

import { LazyContent, LoadingPlaceholder } from "./__internal__/LazyContent";

type IProps = Omit<
  React.ComponentProps<typeof LazyContent>,
  "showMap" | "onShowMap"
>;

export const ExclusivityDetailsModal: React.FC<IProps> = ({
  origin,
  agreementToken,
  brandToken,
  onClose,
}) => {
  const { retailerToken } = useRetailerStore(["retailerToken"]);
  const prefetchDetails = usePrefetchExclusivityDetails();
  const prefetchProtectionZone = usePrefetchProtectionZoneQuery();
  const [showMap, setShowMap] = useState(false);
  const width = useResponsiveValue({
    mobileAndAbove: "100%",
    tabletAndAbove: "383px",
  });

  useEffect(() => {
    if (agreementToken) {
      prefetchDetails(agreementToken);
    }
    prefetchProtectionZone(
      retailerToken ?? "",
      GetProtectionZoneQueryParameters.build({ brand_token: brandToken })
    );
  }, [
    agreementToken,
    brandToken,
    prefetchDetails,
    prefetchProtectionZone,
    retailerToken,
  ]);

  return (
    <Modal
      isOpen
      onClose={onClose}
      onBack={showMap ? () => setShowMap(false) : undefined}
      stickyNav
      width={width}
      align="stretch"
      padding="0"
    >
      <Suspense fallback={<LoadingPlaceholder />}>
        <LazyContent
          origin={origin}
          agreementToken={agreementToken}
          brandToken={brandToken}
          showMap={showMap}
          onShowMap={() => setShowMap(true)}
          onClose={onClose}
        />
      </Suspense>
    </Modal>
  );
};
